import React from 'react';
import { ONBOARDING_VIEWS_MAP } from '../consts/consts';
import { StepIntro } from './StepIntro';
import StepLogo from './StepLogo';
import StepColor from './StepColor';
import StepDetails from './StepDetails';
import { StepPayments } from './StepPayments';
import Spinner, { SpinnerColor } from '../../../../generic-components/Spinner';

interface IProps {
  activeStep: number;
}
export const StepSwitch = ({ activeStep }: IProps) => {
  switch (activeStep) {
    case ONBOARDING_VIEWS_MAP.PRELOAD:
      return <Spinner spinnerColor={SpinnerColor.Blue} height='2rem' width='2rem' />;
    case ONBOARDING_VIEWS_MAP.INTRO:
      return <StepIntro />;
    case ONBOARDING_VIEWS_MAP.LOGO:
      return <StepLogo />;
    case ONBOARDING_VIEWS_MAP.COLOR:
      return <StepColor />;
    case ONBOARDING_VIEWS_MAP.DETAILS:
      return <StepDetails />;
    case ONBOARDING_VIEWS_MAP.PAYMENTS:
      return <StepPayments />;

    default:
      return <StepIntro />;
  }
};
